import React, { FunctionComponent, useEffect, useState } from 'react';
import { DefaultButton, Dialog, DialogFooter, FocusZone, FocusZoneDirection, List, Text } from '@fluentui/react';
import { GroupRole, usersByGroup } from '../../../services/groupRoles.service';
import { trackException } from '../../../services';
import { AxiosError } from 'axios';

interface MemberGroupRoleDialogProps {
  showMemberGroupRoleDialog: boolean;
  setShowMemberGroupRoleDialog: React.Dispatch<React.SetStateAction<boolean>>;
  activeGroupRole: GroupRole;
}

export interface Member {
  displayName: string;
  objectId: string;
  userPrincipalName: string;
}

export const MemberGroupRoleDialog: FunctionComponent<MemberGroupRoleDialogProps> = (props): JSX.Element => {
  const [userAliases, setUserAliases] = useState<Member[]>([]);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    usersByGroup(props.activeGroupRole.groupId)
      .then(data => {
        data.sort((a, b) => {
          const textA = a.displayName.toLowerCase();
          const textB = b.displayName.toLowerCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        setUserAliases(data);
      })
      .catch((err: AxiosError) => {
        setIsError(true);
        err.message = 'MemberGroupRoleDialog: ' + err.message;
        trackException(err);
      });
  }, []);

  // Function to handle dialog close
  const handleButtonClick = () => {
    props.setShowMemberGroupRoleDialog(false);
  };
  React.useEffect(() => {
    const lastFocusedElement = sessionStorage.getItem('lastFocusedElement');
    if (lastFocusedElement) {
      const element = document.getElementById(lastFocusedElement);
      if (element) {
        element.focus();
        sessionStorage.removeItem('lastFocusedElement');
      }
    }
  }, []);

  return (
    <Dialog
      isBlocking={false}
      hidden={!props.showMemberGroupRoleDialog}
      dialogContentProps={{
        title: 'Group Members',
        subText: props.activeGroupRole.groupName
      }}
      modalProps={{
        overlay: {
          isDarkThemed: true
        }
      }}
    >
      {!isError ? (
        <FocusZone direction={FocusZoneDirection.vertical} style={{ marginTop: -16 }}>
          <List
            items={userAliases}
            onRenderCell={user => (
              <ul>
                {user && (
                  <li key={user.userPrincipalName}>
                    <Text>{`${user.displayName} - ${user.userPrincipalName || ''}`}</Text>
                  </li>
                )}
              </ul>
            )}
          />
        </FocusZone>
      ) : (
        <Text>{'Failed to load members, try again later.'}</Text>
      )}

      <DialogFooter>
        <DefaultButton onClick={handleButtonClick} text="Done" />
      </DialogFooter>
    </Dialog>
  );
};
